import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { toast } from "sonner";
import { Check, Loader2 } from "lucide-react";
import api from "@/lib/api";
import { Button } from "@/components/ui/button";
import { useAuth } from "@/context/AuthContext";

export default function AddonManage() {
  const { t, i18n } = useTranslation();
  const { refresh } = useAuth();
  const [s, setS] = useState(null);
  const [busy, setBusy] = useState(false);
  useEffect(() => { api.get("/shop/addon").then((r) => setS(r.data)).catch(() => {}); }, []);
  if (!s?.active) return null;
  const end = s.current_period_end && new Date(s.current_period_end).toLocaleDateString(i18n.language || "en", { month: "long", day: "numeric" });
  const act = async (action) => {
    setBusy(true);
    try {
      const { data } = await api.post(`/shop/addon/${action}`);
      setS(data);
      await refresh();
      toast.success(action === "cancel" ? t("shopAddon.cancelled", { date: end }) : t("shopAddon.resumed"));
    } catch (e) {
      toast.error(e?.response?.data?.detail || t("shopPage.toastError"));
    } finally { setBusy(false); }
  };
  return (
    <div data-testid="shop-addon-manage" className="mt-5 rounded-xl border border-emerald-200 bg-emerald-50 p-3 text-sm">
      <div className="font-semibold text-emerald-900 flex items-center gap-1.5"><Check size={14} /> {t("shopAddon.active")}</div>
      <div className="text-xs text-emerald-800 mt-0.5">
        {s.cancel_at_period_end ? t("shopAddon.endsOn", { date: end }) : t("shopAddon.renewsOn", { date: end })}
      </div>
      <Button size="sm" variant="outline" disabled={busy} onClick={() => act(s.cancel_at_period_end ? "resume" : "cancel")}
        data-testid={s.cancel_at_period_end ? "shop-addon-resume" : "shop-addon-cancel"} className="mt-2 h-8">
        {busy && <Loader2 size={12} className="mr-1.5 animate-spin" />}
        {s.cancel_at_period_end ? t("shopAddon.resume") : t("shopAddon.cancel")}
      </Button>
    </div>
  );
}
